export default function RaList(theme): object {
  return {
    RaList: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.paper,
          borderRadius: theme.spacing(2),
          boxShadow: theme.shadows[2],
          '& .RaList-content': {
            borderRadius: 'unset',
            boxShadow: 'none',

            '& .RaTopToolbar-root': {
              alignItems: 'center',
            },
          },
          '& .MuiTableCell-root': {
            padding: theme.spacing(2),
          },
          '& .RaFilterForm-root': {
            alignItems: 'center',
          },
          '& .filter-field': {
            marginBottom: 0,
            alignItems: 'center',
            '& .RaFilterFormInput-hideButton': {
              marginBottom: 0,
            },
            '& .ra-input': {
              [theme.breakpoints.up('md')]: {
                margin: 0,
              },
            },
          },
        },
      },
    },
  }
}
